import React from "react";
import { ScrollReveal } from "../components/ScrollReveal";

interface ExperienceItemProps {
  period: string;
  title: string;
  subtitle: string;
  description?: string;
}

const ExperienceItem: React.FC<ExperienceItemProps> = ({ period, title, subtitle, description }) => (
  <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-t border-border">
    <div className="md:col-span-3">
      <span className="text-sm text-muted-foreground font-mono">{period}</span>
    </div>
    <div className="md:col-span-9">
      <h3 className="text-lg font-semibold text-foreground tracking-tight">{title}</h3>
      <p className="text-muted-foreground mt-1">{subtitle}</p>
      {description && (
        <p className="text-muted-foreground/80 text-sm mt-3 leading-relaxed max-w-2xl">{description}</p>
      )}
    </div>
  </div>
);

export const Experience: React.FC = () => {
  return (
    <section className="section-space" id="jejak">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="flex items-baseline justify-between mb-4">
            <h2 className="text-sm uppercase tracking-widest text-muted-foreground font-medium">
              Jejak
            </h2>
            <span className="text-sm text-muted-foreground">Pengalaman & Pendidikan</span>
          </div>
        </ScrollReveal>

        <div className="mt-8">
          <ScrollReveal>
            <ExperienceItem
              period="2024"
              title="Web Developer Intern"
              subtitle="Ishpot Coffee"
              description="Berkontribusi dalam pengembangan dan pemeliharaan situs web kafe lokal. Fokus pada implementasi fitur responsif dan optimalisasi performa frontend."
            />
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <ExperienceItem
              period="2023 — 2027"
              title="Telkom University Purwokerto"
              subtitle="S1 Bisnis Digital"
            />
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <ExperienceItem
              period="2019 — 2022"
              title="SMK Telkom Purwokerto"
              subtitle="Rekayasa Perangkat Lunak (RPL)"
            />
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-t border-border">
              <div className="md:col-span-3">
                <span className="text-sm text-muted-foreground font-mono">Sertifikasi</span>
              </div>
              <div className="md:col-span-9">
                <h3 className="text-lg font-semibold text-foreground tracking-tight">Google</h3>
                <ul className="mt-2 space-y-1.5">
                  <li className="text-muted-foreground">Google AI for Professionals</li>
                  <li className="text-muted-foreground">Google Agile Essentials</li>
                </ul>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};
